import { useMemo } from "react";

import { useStores, useMeasureUnits, usePriceLists } from "shared-apis";

/**
 * Справочные данные для документов: склады, ед. изм., прайслисты.
 * Товары НЕ грузятся целиком — только через серверный поиск (ItemSelect).
 */
export const useDocReferenceData = () => {
  const storesQuery = useStores();
  const measureUnitsQuery = useMeasureUnits();
  const priceListsQuery = usePriceLists();

  const stores = storesQuery.data?.items ?? [];
  const measureUnits = measureUnitsQuery.data?.items ?? [];
  const priceLists = priceListsQuery.data?.items ?? [];

  const storesOptions = useMemo(
    () => stores.map((s) => ({ value: String(s.storesid), label: s.name })),
    [stores]
  );

  const measureUnitsOptions = useMemo(
    () => measureUnits.map((m) => ({ value: String(m.measureid), label: m.name })),
    [measureUnits]
  );

  const priceListsOptions = useMemo(
    () => priceLists.map((p) => ({ value: String(p.pricelistid), label: p.name })),
    [priceLists]
  );

  return {
    stores,
    measureUnits,
    priceLists,
    storesOptions,
    measureUnitsOptions,
    priceListsOptions,
    isLoading:
      storesQuery.isLoading ||
      measureUnitsQuery.isLoading ||
      priceListsQuery.isLoading,
  };
};
